const initialState = {
  fetching: false,
  fetched: false,
  deleting: false,
  masking: false,
  archiving: false,
  items: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1,
  openDeleteConfirm: false,
  checks: []
};
export const mediasReducerByType = (type = "ALL") => (
  state = initialState,
  action
) => {
  const t = type.toUpperCase();

  switch (action.type) {
    case `RESET_MEDIAS_${t}`: {
      return initialState;
    }
    case `FETCH_MEDIAS_${t}_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_MEDIAS_${t}_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_MEDIAS_${t}_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `FETCH_INFINITE_MEDIAS_${t}_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_INFINITE_MEDIAS_${t}_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case `FETCH_INFINITE_MEDIAS_${t}_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case `DELETE_FROM_LIST_MEDIA_${t}`: {
      return {
        ...state,
        items: state.items.filter(med => med.id !== action.media.id)
      };
    }

    default:
      return state;
  }
};

export const mediasListingReducer = () => (state = initialState, action) => {
  switch (action.type) {
    case `RESET_MEDIAS`: {
      return initialState;
    }
    case `FETCH_MEDIAS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_MEDIAS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_MEDIAS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }

    case `SAVE_MEDIA_FULFILLED`: {
      const { data } = action.payload.data;

      // // let isLogo = false;
      let help = { ...data };
      if (data.objectType === "MASK" || data.objectType === "LOGO") {
        help.docType = data.objectType;
        // isLogo = true;
      }
      if (help.docType !== "MASK" && help.docType !== "LOGO") {
        const media = state.items.find(item => item.id === data.id);

        if (!media) {
          // new uploaded media
          return {
            ...state,
            // items: isLogo ? [...state.items, help] : [help, ...state.items],
            items: [help, ...state.items],
            nbResult: state.nbResult + 1
          };
        }

        const newMedia = { ...media, ...data };
        const newMedias = state.items.map(item => {
          if (item.id === newMedia.id) {
            return newMedia;
          }

          return item;
        });
        return {
          ...state,
          items: newMedias
        };
      }

      return state;
    }

    case "DELETE_MEDIAS_PENDING": {
      return {
        ...state,
        deleting: true
      };
    }
    case "DELETE_MEDIAS_FULFILLED": {
      const resp = action.payload.data;
      if (resp.warning) {
        const notDeletedIds = resp.data.ids;
        return {
          ...state,
          deleting: false,
          openDeleteConfirm: false,
          items: state.items.filter(
            item =>
              !state.checks
                .map(media => media.id)
                .filter(id => !notDeletedIds.includes(id))
                .includes(item.id)
          ),
          checks: state.checks.filter(media =>
            notDeletedIds.includes(media.id)
          ),
          error: null
        };
      }
      return {
        ...state,
        deleting: false,
        openDeleteConfirm: false,
        items: state.items.filter(
          item => !state.checks.map(media => media.id).includes(item.id)
        ),
        checks: [],
        error: null
      };
    }
    case "DELETE_MEDIAS_REJECTED": {
      let error = action.payload;
      return {
        ...state,
        deleting: false,
        error
      };
    }

    case "MASK_MEDIAS_PENDING": {
      return {
        ...state,
        masking: true
      };
    }
    case "MASK_MEDIAS_FULFILLED": {
      return {
        ...state,
        masking: false,
        items: state.items.filter(
          item => !state.checks.map(media => media.id).includes(item.id)
        ),
        checks: [],
        error: null
      };
    }
    case "MASK_MEDIAS_REJECTED": {
      let error = action.payload;
      return {
        ...state,
        masking: false,
        error
      };
    }

    case "ARCHIVE_MEDIAS_PENDING": {
      return {
        ...state,
        archiving: true
      };
    }
    case "ARCHIVE_MEDIAS_FULFILLED": {
      return {
        ...state,
        archiving: false,
        items: state.items.filter(
          item => !state.checks.map(media => media.id).includes(item.id)
        ),
        checks: [],
        error: null
      };
    }
    case "ARCHIVE_MEDIAS_REJECTED": {
      let error = action.payload;
      return {
        ...state,
        archiving: false,
        error
      };
    }

    case "TOGGLE_SELECT_MEDIA": {
      const ids = state.checks.map(media => media.id);
      return {
        ...state,
        checks: ids.includes(action.payload.id)
          ? state.checks.filter(media => media.id !== action.payload.id)
          : state.checks.concat([action.payload])
      };
    }

    case "RESET_SELECTED_MEDIA": {
      return {
        ...state,
        checks: []
      };
    }

    case "SET_OPEN_DELETE_CONFIRM": {
      return {
        ...state,
        openDeleteConfirm: action.payload
      };
    }

    default:
      return state;
  }
};

export const mediasLogoReducer = () => (state = initialState, action) => {
  switch (action.type) {
    case `RESET_MEDIAS_LOGO`: {
      return initialState;
    }
    case `FETCH_MEDIAS_LOGO_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_MEDIAS_LOGO_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_MEDIAS_LOGO_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `FETCH_INFINITE_MEDIAS_LOGO_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_INFINITE_MEDIAS_LOGO_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case `FETCH_INFINITE_MEDIAS_LOGO_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case `DELETE_FROM_LIST_MEDIA_LOGO`: {
      return {
        ...state,
        items: state.items.filter(med => med.id !== action.media.id)
      };
    }

    case `SAVE_MEDIA_FULFILLED`: {
      const { data } = action.payload.data;
      let help = { ...data };
      if (data.objectType === "LOGO") {
        help.docType = data.objectType;
        const logo = state.items.find(item => item.id === data.id);

        if (!logo) {
          return {
            ...state,
            items: [help, ...state.items],
            nbResult: state.nbResult + 1
          };
        }
      }
      return state;
    }

    default:
      return state;
  }
};

export const mediasMaskReducer = () => (state = initialState, action) => {
  switch (action.type) {
    case `RESET_MEDIAS_MASK`: {
      return initialState;
    }
    case `FETCH_MEDIAS_MASK_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_MEDIAS_MASK_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_MEDIAS_MASK_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `FETCH_INFINITE_MEDIAS_MASK_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_INFINITE_MEDIAS_MASK_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case `FETCH_INFINITE_MEDIAS_MASK_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case `DELETE_FROM_LIST_MEDIA_MASK`: {
      return {
        ...state,
        items: state.items.filter(med => med.id !== action.media.id)
      };
    }

    case `SAVE_MEDIA_FULFILLED`: {
      const { data } = action.payload.data;
      let help = { ...data };
      if (data.objectType === "MASK") {
        help.docType = data.objectType;
        const logo = state.items.find(item => item.id === data.id);

        if (!logo) {
          return {
            ...state,
            items: [help, ...state.items],
            nbResult: state.nbResult + 1
          };
        }
      }
      return state;
    }

    default:
      return state;
  }
};

export const topMediasReducer = () => (state = initialState, action) => {
  switch (action.type) {
    case `RESET_TOP_MEDIAS`: {
      return initialState;
    }
    case `FETCH_TOP_MEDIAS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_TOP_MEDIAS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_TOP_MEDIAS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    case `SAVE_MEDIA_FULFILLED`: {
      const { data } = action.payload.data;
      const media = state.items.find(item => item.id === data.id);
      if (media) {
        if (media.inTheNews !== data.inTheNews) {
          return {
            ...state,
            items: state.items.filter(item => item.id !== data.id)
          };
        }
      } else if (data.inTheNews) {
        return {
          ...state,
          items: [data, ...state.items]
        };
      }

      return {
        ...state
      };
    }

    default:
      return state;
  }
};

const uploadingMediasInitialState = {
  // fetching: false,
  // fetched: false,
  items: []
  // error: null,
  // nbResult: 0,
  // paginationPage: 1,
  // paginationTotalPages: 1
};
export const uploadingMediasReducer = (
  state = uploadingMediasInitialState,
  action
) => {
  switch (action.type) {
    case "ADD_UPLOADING_MEDIAS": {
      return { ...state, items: state.items.concat(action.items) };
    }
    case "SET_UPLOADING_MEDIAS": {
      return { ...state, items: action.items };
    }
    default:
      return state;
  }
};

const initialUsedState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1,
  addMediaModalOpened: false,
  checks: [],
  filter: "ALL"
};
export const usedMediasReducer = (state = initialUsedState, action) => {
  switch (action.type) {
    case "INIT_USED_MEDIAS": {
      return initialUsedState;
    }
    case "RESET_USED_MEDIA": {
      return { ...initialUsedState };
    }
    case "FETCH_USED_MEDIAS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_USED_MEDIAS_FULFILLED": {
      const { data, nbResult } = action.payload.data;
      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case "FETCH_USED_MEDIAS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case `ADD_TO_LIBRARY_PENDING`: {
      return state;
    }

    case `ADD_TO_LIBRARY_FULFILLED`: {
      return state;
    }

    case `UNSHIFT_USED_MEDIA`: {
      const help = [...state.items];
      help.unshift(action.media);

      return {
        ...state,
        items: [...help]
      };
    }

    case "SET_ADD_MEDIA_MODAL_OPENED": {
      return {
        ...state,
        addMediaModalOpened: action.payload
      };
    }

    case "SET_MEDIAS_FILTER": {
      return {
        ...state,
        filter: "IMAGE"
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/media.js